import type { FC } from "react";

import type { EcommerceReassuranceBannerItem } from "@jti/ui/components/EcommerceReassuranceBanner";
import { EcommerceReassuranceBanner as UIEcommerceReassuranceBanner } from "@jti/ui/components/EcommerceReassuranceBanner";
import { dropdownMapper } from "@jti/ui/components/EcommerceReassuranceBanner/dropdownMapper";

import type { ecommerceReassuranceBannerInputs } from "./EcommerceReassuranceBanner.builder";

export type EcommerceReassuranceBannerProps = BuilderComponentProps<typeof ecommerceReassuranceBannerInputs>;

export const EcommerceReassuranceBanner: FC<EcommerceReassuranceBannerProps> = ({ items, theme, title }) => {
  if (items.length === 0) return null;

  const ecommerceReassuranceBannerItems: EcommerceReassuranceBannerItem[] = items.map(
    (item): EcommerceReassuranceBannerItem => ({
      id: item.description,
      iconName: dropdownMapper[item.icon] ?? "account",
      description: item.description,
      href: item.href,
    })
  );

  return <UIEcommerceReassuranceBanner theme={theme} title={title} items={ecommerceReassuranceBannerItems} />;
};
